module.exports = __webpack_public_path__ + "media/images/check2-e1da0b884294faaac2818ce0c275e620.svg";